import data from './totalTooltip.json'

export default data.data
